module.exports = __webpack_public_path__ + "static/media/times-red.58e3b677.svg";